import config from 'coeus.config';

const defaultUserFields = [
    'name',
    'email',
    'phone',
    'qsId',
    'directory',
    'role',
];

export const generateUserEditKeys = () => {
    const { custom_fields: fields } = config.user;
    const additionalFields = fields ? fields.map((field) => field.id) : [];
    return [...defaultUserFields, ...additionalFields];
};
